export class EventBus {
  constructor() {
    this.listeners = {};
  }

  on(event, fn) {
    if (!this.listeners[event]) {
      this.listeners[event] = new Set();
    }
    this.listeners[event].add(fn);

    return () => this.listeners[event].delete(fn);
  }

  emit(event, payload) {
    if (this.listeners[event]) {
      for (const fn of this.listeners[event]) {
        fn(payload);
      }
    }
  }
}

export const globalEventBus = new EventBus();
